import React from 'react';
import styled from 'styled-components';
import { Alert } from '../molecules/Alert';
import { AgreementCheckBox } from '../atoms/AgreementCheckBox';
import { RequiredLabel } from '../atoms/RequiredLabel';
import { Button } from '../atoms/Button';
import { FeedbackNotice } from '../molecules/FeedbackNotice';

type Props = {
  isAgreed: boolean;
  onAgreeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const FeedbackAgreementSubmit = ({ isAgreed, onAgreeChange }: Props): JSX.Element => {
  const disabled = !isAgreed;

  return (
    <>
      <Alert severity="warning" title="個別の返信が必要な場合はカスタマーサポートにご連絡ください">
        <FeedbackNotice />
      </Alert>

      <FlexBox>
        <AgreementCheckBox checked={isAgreed} onChange={onAgreeChange}>
          個別の返信を受け取らないことに同意する
        </AgreementCheckBox>
        <RequiredLabel />
      </FlexBox>

      <Submit type="submit" disabled={disabled}>
        送信
      </Submit>
    </>
  );
};

const FlexBox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1.2em;
`;

const Submit = styled(Button)`
  display: block;
  width: 100%;
  max-width: 320px;
  margin: 2rem auto 0;
`;
